import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../../components/SEOHead';

export default function BlogPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleMobileMenuClick = (targetId: string) => {
    setIsMobileMenuOpen(false);
    
    setTimeout(() => {
      const element = document.querySelector(targetId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  const toggleMobileMenu = (e: React.MouseEvent | React.TouchEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsMobileMenuOpen(prev => !prev);
  };

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const blogArticles = [
    {
      id: 1,
      slug: 'what-is-grid-battery-business',
      title: '系統用蓄電池事業とは？初心者でもわかる基礎知識と仕組み',
      excerpt: '系統用蓄電池事業は、安価な電力を蓄電池に貯蔵し、需要ピーク時に高値で販売するビジネスモデルです。東京電力管内での系統用蓄電池事業の基本的な仕組みと収益構造について、初心者にもわかりやすく解説します。',
      date: '2025年1月15日',
      dateISO: '2025-01-15',
      category: '基礎知識',
      image: 'https://public.readdy.ai/ai/img_res/96fe477412b27e98df7bfd56b32ab218.jpg',
      readTime: '5分'
    },
    {
      id: 2,
      slug: 'tokyo-electric-power-area-advantages',
      title: '東京電力管内で系統用蓄電池事業が有利な理由',
      excerpt: '東京電力管内は系統用蓄電池事業において全国で最も有利なエリアです。変電所の空き容量、電力需要の安定性、市場規模など、東京電力管内での系統用蓄電池投資が選ばれる理由を詳しく解説します。',
      date: '2025年1月12日',
      dateISO: '2025-01-12',
      category: '市場分析',
      image: 'https://readdy.ai/api/search-image?query=tokyo%20metropolitan%20area%20aerial%20view%20with%20electric%20power%20grid%20infrastructure%20and%20transmission%20lines%2C%20modern%20city%20skyline%20with%20energy%20distribution%20network%2C%20professional%20business%20illustration%20with%20teal%20accents&width=800&height=600&seq=blog-tokyo-power-2&orientation=landscape',
      readTime: '7分'
    },
    {
      id: 3,
      slug: 'battery-investment-revenue-model',
      title: '系統用蓄電池投資の収益モデル完全ガイド',
      excerpt: '系統用蓄電池事業では容量市場、卸電力市場、需給調整市場の3つの市場から収益を得られます。各市場の特徴と収益構造、実際の収益シミュレーションまで、系統用蓄電池投資の収益モデルを徹底解説します。',
      date: '2025年1月10日',
      dateISO: '2025-01-10',
      category: '投資ガイド',
      image: 'https://readdy.ai/api/search-image?query=financial%20growth%20chart%20and%20revenue%20analysis%20dashboard%20showing%20upward%20trends%2C%20professional%20business%20analytics%20with%20green%20and%20teal%20color%20scheme%2C%20investment%20profit%20visualization%20with%20clean%20modern%20design&width=800&height=600&seq=blog-revenue-model-3&orientation=landscape',
      readTime: '8分'
    },
    {
      id: 4,
      slug: 'llp-investment-structure',
      title: 'LLP投資で始める系統用蓄電池事業のメリット',
      excerpt: 'LLP（有限責任事業組合）を活用した系統用蓄電池事業への投資は、1,100万円から参加可能で、リスクを分散しながら安定収益を目指せます。LLP投資の仕組みとメリットを詳しく解説します。',
      date: '2025年1月8日',
      dateISO: '2025-01-08',
      category: '投資手法',
      image: 'https://readdy.ai/api/search-image?query=business%20partnership%20handshake%20with%20professional%20team%20collaboration%2C%20corporate%20investment%20meeting%20with%20documents%20and%20charts%2C%20modern%20office%20setting%20with%20teal%20and%20blue%20corporate%20colors&width=800&height=600&seq=blog-llp-invest-4&orientation=landscape',
      readTime: '6分'
    },
    {
      id: 5,
      slug: 'battery-business-risk-management',
      title: '系統用蓄電池事業のリスク管理と対策',
      excerpt: '系統用蓄電池事業における自然災害リスク、市場変動リスク、設備故障リスクなど、各種リスクとその対策方法を解説。保険活用やメンテナンス体制など、安全な系統用蓄電池投資のためのリスク管理手法をご紹介します。',
      date: '2025年1月5日',
      dateISO: '2025-01-05',
      category: 'リスク管理',
      image: 'https://readdy.ai/api/search-image?query=risk%20management%20and%20safety%20protection%20concept%20with%20shield%20and%20security%20symbols%2C%20professional%20business%20insurance%20and%20protection%20illustration%2C%20clean%20modern%20design%20with%20blue%20and%20teal%20colors&width=800&height=600&seq=blog-risk-mgmt-5&orientation=landscape',
      readTime: '7分'
    },
    {
      id: 6,
      slug: 'funding-options-for-battery-business',
      title: '系統用蓄電池事業の資金調達方法を徹底比較',
      excerpt: '系統用蓄電池事業を始めるための資金調達方法として、設備資材リース型、共同経営型、クラウドファンディング型など、各方法のメリット・デメリットを比較。あなたに最適な資金調達方法を見つけましょう。',
      date: '2025年1月3日',
      dateISO: '2025-01-03',
      category: '資金調達',
      image: 'https://readdy.ai/api/search-image?query=financial%20funding%20and%20investment%20options%20concept%20with%20money%20flow%20and%20capital%20allocation%2C%20professional%20business%20finance%20illustration%20with%20charts%20and%20graphs%2C%20modern%20clean%20design%20with%20green%20accents&width=800&height=600&seq=blog-funding-6&orientation=landscape',
      readTime: '9分'
    }
  ];

  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Blog",
        "@id": `${siteUrl}/blog#blog`,
        "url": `${siteUrl}/blog`,
        "name": "系統用蓄電池事業ブログ - 株式会社新藤不動産",
        "description": "系統用蓄電池事業に関する最新情報、投資ガイド、市場分析など、東京電力管内での系統用蓄電池投資に役立つ情報を発信しています。",
        "publisher": {
          "@type": "Organization",
          "name": "株式会社新藤不動産",
          "logo": {
            "@type": "ImageObject",
            "url": "https://static.readdy.ai/image/429f3598ecc5059f29a02a26bec35937/17c45356e81e22a47455156ff6042e28.png"
          }
        },
        "blogPost": blogArticles.map(article => ({
          "@type": "BlogPosting",
          "@id": `${siteUrl}/blog/${article.slug}#article`,
          "headline": article.title,
          "description": article.excerpt,
          "datePublished": article.dateISO,
          "author": {
            "@type": "Organization",
            "name": "株式会社新藤不動産"
          },
          "publisher": {
            "@type": "Organization",
            "name": "株式会社新藤不動産"
          },
          "image": article.image,
          "url": `${siteUrl}/blog/${article.slug}`,
          "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": `${siteUrl}/blog/${article.slug}`
          }
        }))
      },
      {
        "@type": "WebPage",
        "@id": `${siteUrl}/blog#webpage`,
        "url": `${siteUrl}/blog`,
        "name": "系統用蓄電池事業ブログ | 株式会社新藤不動産 - 東京電力管内専門",
        "description": "系統用蓄電池事業の基礎知識から投資ガイド、市場分析まで。東京電力管内での系統用蓄電池投資に役立つ情報を発信。系統用蓄電池事業の専門企業が解説します。",
        "inLanguage": "ja"
      }
    ]
  };

  return (
    <>
      <SEOHead
        title="系統用蓄電池事業ブログ | 株式会社新藤不動産 - 東京電力管内専門の系統用蓄電池投資情報"
        description="系統用蓄電池事業の基礎知識から投資ガイド、市場分析まで。東京電力管内での系統用蓄電池投資に役立つ情報を発信。系統用蓄電池事業の専門企業、株式会社新藤不動産が系統用蓄電池事業のあらゆる情報を解説します。"
        keywords="系統用蓄電池事業,系統用蓄電池,蓄電池投資,東京電力管内,蓄電池ブログ,エネルギー投資,LLP投資,グリッドビヨンド,再生可能エネルギー"
        canonical={`${siteUrl}/blog`}
        schema={schema}
      />

      <div className="min-h-screen bg-white">
        {/* Navigation */}
        <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white shadow-sm'}`}>
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="flex justify-between items-center h-20">
              <Link to="/" className="flex items-center">
                <img 
                  src="https://static.readdy.ai/image/429f3598ecc5059f29a02a26bec35937/17c45356e81e22a47455156ff6042e28.png"
                  alt="株式会社新藤不動産"
                  className="h-12"
                />
                <div className="ml-4 text-xl font-bold text-gray-900">株式会社新藤不動産</div>
              </Link>
              <div className="hidden md:flex items-center space-x-8">
                <Link to="/" className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors whitespace-nowrap">ホーム</Link>
                <Link to="/blog" className="text-sm font-medium text-teal-600 transition-colors whitespace-nowrap">ブログ</Link>
                <Link to="/#properties" className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors whitespace-nowrap">売却案件</Link>
                <Link to="/#contact" className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors whitespace-nowrap">お問い合わせ</Link>
              </div>
              <div 
                className="md:hidden cursor-pointer p-3 -mr-2 active:bg-gray-100 rounded-lg transition-colors"
                onClick={toggleMobileMenu}
                onTouchEnd={toggleMobileMenu}
                role="button"
                aria-label="メニュー"
                aria-expanded={isMobileMenuOpen}
              >
                <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-3xl text-gray-900`}></i>
              </div>
            </div>
          </div>

          {/* Mobile Menu */}
          <div 
            className={`md:hidden bg-white border-t border-gray-200 shadow-lg transition-all duration-300 overflow-hidden ${
              isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
            }`}
          >
            <div className="px-6 py-4 space-y-3">
              <Link 
                to="/"
                className="block w-full text-left text-base font-medium text-gray-900 hover:text-teal-600 active:text-teal-700 transition-colors py-3 border-b border-gray-100"
              >
                ホーム
              </Link>
              <Link 
                to="/blog"
                className="block w-full text-left text-base font-medium text-teal-600 transition-colors py-3 border-b border-gray-100"
              >
                ブログ
              </Link>
              <Link 
                to="/#properties"
                className="block w-full text-left text-base font-medium text-gray-900 hover:text-teal-600 active:text-teal-700 transition-colors py-3 border-b border-gray-100"
              >
                売却案件
              </Link>
              <Link 
                to="/#contact"
                className="block w-full text-left text-base font-medium text-gray-900 hover:text-teal-600 active:text-teal-700 transition-colors py-3"
              >
                お問い合わせ
              </Link>
            </div>
          </div>
        </nav>

        {/* Hero Section */}
        <section className="pt-32 pb-16 bg-gradient-to-br from-teal-50 via-white to-teal-50">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                <strong>系統用蓄電池事業</strong>ブログ
              </h1>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                <strong>系統用蓄電池事業</strong>の基礎知識から投資ガイド、市場分析まで。<strong>東京電力管内</strong>での<strong>系統用蓄電池投資</strong>に役立つ情報を発信しています。
              </p>
            </div>
          </div>
        </section>

        {/* Blog Articles Grid */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {blogArticles.map((article) => (
                <article key={article.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                  <div className="relative h-64 w-full overflow-hidden">
                    <img 
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute top-4 left-4">
                      <span className="bg-teal-600 text-white px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap">
                        {article.category}
                      </span>
                    </div>
                  </div>
                  <div className="p-6">
                    <div className="flex items-center text-sm text-gray-500 mb-3">
                      <i className="ri-calendar-line mr-2"></i>
                      <span>{article.date}</span>
                      <span className="mx-2">•</span>
                      <i className="ri-time-line mr-2"></i>
                      <span>{article.readTime}</span>
                    </div>
                    <h2 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                      {article.title}
                    </h2>
                    <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                      {article.excerpt}
                    </p>
                    <Link 
                      to={`/blog/${article.slug}`}
                      className="inline-flex items-center text-teal-600 hover:text-teal-700 font-semibold text-sm transition-colors cursor-pointer"
                    >
                      続きを読む
                      <i className="ri-arrow-right-line ml-2"></i>
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-gradient-to-br from-teal-50 to-blue-50">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              <strong>系統用蓄電池事業</strong>に関するご相談はこちら
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              <strong>東京電力管内</strong>での<strong>系統用蓄電池投資</strong>について、専門スタッフが丁寧にご対応いたします。
            </p>
            <Link 
              to="/#contact"
              className="inline-block bg-teal-600 hover:bg-teal-700 text-white px-12 py-4 rounded-lg text-base font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              お問い合わせはこちら
            </Link>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-gray-900 text-white py-16">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12">
              <div>
                <div className="mb-4">
                  <img 
                    src="https://static.readdy.ai/image/429f3598ecc5059f29a02a26bec35937/17c45356e81e22a47455156ff6042e28.png"
                    alt="株式会社新藤不動産"
                    className="h-12"
                  />
                  <p className="text-xl font-bold text-white mt-3">株式会社新藤不動産</p>
                  <p className="text-xl font-bold text-white">JV 株式会社マック</p>
                </div>
                <p className="text-gray-400 text-sm leading-relaxed">
                  系統用蓄電池の投資事業を専門とする会社です。
                </p>
              </div>
              <div>
                <h4 className="font-bold text-lg mb-4">サイトメニュー</h4>
                <div className="space-y-2">
                  <Link to="/" className="block text-gray-400 text-sm hover:text-white cursor-pointer">ホーム</Link>
                  <Link to="/blog" className="block text-gray-400 text-sm hover:text-white cursor-pointer">ブログ</Link>
                  <Link to="/#properties" className="block text-gray-400 text-sm hover:text-white cursor-pointer">売却案件</Link>
                  <Link to="/#contact" className="block text-gray-400 text-sm hover:text-white cursor-pointer">お問い合わせ</Link>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-400 text-sm mb-4 md:mb-0">© 2024 株式会社新藤不動産. All rights reserved.</p>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">Powered by Readdy</a>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}
